module.exports = __webpack_public_path__ + "static/media/move-up-white.b548b8f9.svg";